var map = {
	"./asset_ui/src/pages/context.js": 52019,
	"./communication_ui/src/pages/context.js": 27387,
	"./file_ui/src/pages/context.js": 9371,
	"./invoice_ui/src/pages/context.js": 55970,
	"./ks_app/src/pages/context.js": 99342,
	"./lms_ui/src/pages/context.js": 31115,
	"./market_ui/src/pages/context.js": 88945,
	"./marketing_ui/src/pages/context.js": 51535,
	"./payment_ui/src/pages/context.js": 41713,
	"./rms_ui/src/pages/context.js": 76345,
	"./task_ui/src/pages/context.js": 58334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38427;